import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/services/funding/loans/page.tsx");
